// extracted by mini-css-extract-plugin
export default {"markdown-confirm":"styles__markdown-confirm--OP57F","content":"styles__content--+qZ8Q","question":"styles__question--VCdJc","actions":"styles__actions--RFwFe"};